"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wxInit = wxInit;
exports.myInit = myInit;
exports.ttInit = ttInit;
exports.swanInit = swanInit;
exports.ksInit = ksInit;
exports.jdInit = jdInit;
exports.default = void 0;
var _loadScript = _interopRequireDefault(require("@xpeng/load-script"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * @param {String} url
 * @returns
 */
function load(url) {
  return (0, _loadScript.default)(url).catch(function () {
    return (0, _loadScript.default)(url);
  });
}
function noop() {}
/**
 * 微信 SDK 初始化的调用方法
 *
 * @returns {Promise<Weixin>}
 */

function wxInit() {
  // 避免重复加载
  if (window.wx && typeof window.wx.config === 'function') {
    return Promise.resolve(window.wx);
  } // 非微信内置浏览器直接略过处理
  // 提供一个假的 wx 供全局调用避免异常

  if (!/MicroMessenger/gi.test(navigator.userAgent)) {
    var faker = {
      __isFaker: true
    };
    ['ready', 'config', 'error'].forEach(function (item) {
      return faker[item] = noop;
    });
    window.wx = faker;
    return Promise.resolve(window.wx);
  } // 加载 jssdk 后初始化

  return load('//res.wx.qq.com/open/js/jweixin-1.6.0.js').then(function () {
    return Promise.resolve(window.wx);
  });
}
function myInit() {
  // 避免重复加载
  if (window.my && window.my.navigateTo) {
    return Promise.resolve(window.my);
  } // 加载 jssdk 后初始化

  return load('//appx/web-view.min.js').then(function () {
    return Promise.resolve(window.my);
  });
}
function ttInit() {
  // 避免重复加载
  if (window.tt && window.tt.miniProgram) {
    return Promise.resolve(window.tt);
  } // 加载 jssdk 后初始化

  return load('//s.xiaopeng.com/xp-fe/mini/js/tt/jssdk-1.0.1.js').then(function () {
    return Promise.resolve(window.tt);
  });
}
function swanInit() {
  // 避免重复加载
  if (window.swan && window.swan.webView) {
    return Promise.resolve(window.swan);
  } // 加载 jssdk 后初始化

  return load('//s.xiaopeng.com/xp-fe/mini/js/swan/swan-2.0.22.js').then(function () {
    return Promise.resolve(window.swan);
  });
}
function ksInit() {
  // 避免重复加载
  if (window.ks && window.ks.webView) {
    return Promise.resolve(window.ks);
  }
  return Promise.resolve(window.ks);
}
function jdInit() {
  // 避免重复加载
  if (window.jd && window.jd.miniProgram) {
    return Promise.resolve(window.jd);
  } // 加载 jssdk 后初始化

  return load('//s.xiaopeng.com/xp-fe/mini/js/jd/jssdk.js').then(function () {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve(window.jd);
      }, 300);
    });
  });
}
var _default = {
  wxInit: wxInit,
  myInit: myInit,
  ttInit: ttInit,
  swanInit: swanInit,
  ksInit: ksInit,
  jdInit: jdInit
};
exports.default = _default;